<template>
  <div class="payments-container">
    <SecurePaymentMethods />
    <YourPaymentsProtected />
  </div>
</template>

<script lang="ts" setup>
import SecurePaymentMethods from './SecurePaymentMethods.vue'
import YourPaymentsProtected from './YourPaymentsProtected.vue'
</script>

<style scoped lang="scss">
.payments-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
}
</style>
